import router from './router/index';
import store from './store';

// 路由权限控制
router.beforeEach((to, from, next) => {
    if (to.path == '/login') {
        next();
    } else {
        if (!store.state.token) {
            next('/login');
        } else {
            next();
        }
    }
});
